
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claims/status/[claimNumber]/DocumentsNeeded",
      function () {
        return require("private-next-pages/claims/status/[claimNumber]/DocumentsNeeded.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claims/status/[claimNumber]/DocumentsNeeded"])
      });
    }
  